import axios from "axios";
import { logoutUser } from "../ReduxStore/userReducer";
import { resetItemGroup, resetItems } from "../ReduxStore/actions";
import { showAlert } from "../ReduxStore/alertSlice";
// import { useAlert } from "../sharedFiles/AlertContext/AlertContext";

export const GetData = async (DataAPI, Params, dispatch, navigate) => {
    try {
        const response = await axios.get(DataAPI, Params);
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.data === 'Invalid token')) {
            // console.log("Customer error:", error);
            dispatch(logoutUser());
            dispatch(resetItemGroup());
            dispatch(resetItems());
            dispatch(showAlert());
            navigate('/');          
        }
        throw error;
    }
};